import type { $ } from "../../../dom";
import { MultiInput, type MultiInputOptions } from "../../core";
import { CheckboxInput } from "./checkbox-input";

export type CheckboxGroupInputOptions<TValue> = MultiInputOptions<TValue> & {};

export abstract class CheckboxGroupInput<
  TValue,
  TData = TValue,
> extends MultiInput<TValue, TData> {
  public abstract inputs: CheckboxInput<TValue, TData>[];

  constructor($root: $, options?: CheckboxGroupInputOptions<boolean[]>) {
    const { ...superOptions } = options ?? {};

    super($root, superOptions);
  }

  toggleAll(value: boolean): void {
    this.inputs.forEach((input) => {
      input.isActive = value;
    });
  }
}
